const AutocompleteTheme = {
  baseStyle: {
    container: {
      position: "relative",
      width: "100%",
    },
    list: {
      mt: 1,
      border: "1px solid",
      borderColor: "border",
      borderRadius: "10px", // same as Input
      bg: "inputBackground",
      shadow: "lg",
      maxH: "240px",
      overflowY: "auto",
      zIndex: 10,
    },
    item: {
      px: 3,
      py: 2,
      fontSize: "sm",
      lineHeight: "short",
      color: "neutral.textPrimary",
      cursor: "pointer",
      transition: "background 0.2s ease",
      _hover: {
        bg: "orange.50",
      },
      _active: {
        bg: "orange.100",
      },
    },
  },
};

export default AutocompleteTheme;
